// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalculatorTwoToneSvg from "@fishx/icons-svg/es/asn/CalculatorTwoTone";
import FishxIcon from '../components/FishxIcon';

var CalculatorTwoTone = function CalculatorTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorTwoToneSvg
  }));
};

CalculatorTwoTone.displayName = 'CalculatorTwoTone';
export default React.forwardRef(CalculatorTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CalculatorTwoTone.js
// module id = 2148
// module chunks = 0